import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { MERCHANT_TYPE } from '../enums';

@Pipe({
  name: 'merchantType'
})
export class MerchantTypePipe extends EnumConverter implements PipeTransform {
  enumeration = MERCHANT_TYPE;
}
